export enum VestigingEnum {
  Geen = 0,
  Aalsmeer = 1,
  Naaldwijk = 2,
  Rijnsburg = 3,
  Eelde = 7,
}

export enum WareHouseSearchOptions {
  Alle = 0,
  Aalsmeer = 1,
  Naaldwijk = 2,
  Rijnsburg = 3,
  Eelde = 7,
}

export enum MessageType {
  YesNo,
  Ok,
  OkCancel,
  YesNoCancel,
}

export enum Answer {
  Yes,
  No,
  Ok,
  Cancel,
}

export enum HistoryScope {
  Default = 1,
  History7Day = 2,
  HistoryAll = 3,
}

export const historyScopeOptions: HistoryScope[] = [
  HistoryScope.Default,
  HistoryScope.History7Day,
  HistoryScope.HistoryAll,
]

export const vestigingen: VestigingEnum[] = [
  VestigingEnum.Geen,
  VestigingEnum.Aalsmeer,
  VestigingEnum.Naaldwijk,
  VestigingEnum.Rijnsburg,
  VestigingEnum.Eelde,
]

export const warehouseOptions: WareHouseSearchOptions[] = [
  WareHouseSearchOptions.Alle,
  WareHouseSearchOptions.Aalsmeer,
  WareHouseSearchOptions.Naaldwijk,
  WareHouseSearchOptions.Rijnsburg,
  WareHouseSearchOptions.Eelde,
]

export enum GroepTypeEnum {
  Aflevertijd = 1,
  Afleverlocatie = 2,
}

export const groepTypes: GroepTypeEnum[] = [
  GroepTypeEnum.Aflevertijd,
  GroepTypeEnum.Afleverlocatie,
]

export enum SortVolgordeEnum {
  KlantNummer = 0,
  KlantEan = 1,
  Vestiging = 2,
  KlantGroep = 3,
  KlantNaam = 4,
  AfleverafspraakReferentie = 5,
  MutatieDatumTijd = 6,
  MutatieGebruiker = 7,
}

export enum DaysOfWeek {
  Zo = 0,
  Ma = 1,
  Di = 2,
  Wo = 3,
  Do = 4,
  Vr = 5,
  Za = 6,
  Alle = 99,
}

export const daysOfWeekOptions: DaysOfWeek[] = [
  DaysOfWeek.Zo,
  DaysOfWeek.Ma,
  DaysOfWeek.Di,
  DaysOfWeek.Wo,
  DaysOfWeek.Do,
  DaysOfWeek.Vr,
  DaysOfWeek.Za,
  DaysOfWeek.Alle,
]

export enum RoleNames {
  LboGlnOnderhouden = 'LboGlnOnderhouden',
  LboKlantGroepenOnderhouden = 'LboKlantGroepenOnderhouden',
}

export const exceloptions = {
  fieldSeparator: ';',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  showTitle: true,
  title: 'sep=;',
  useTextFile: false,
  useBom: true,
  useKeysAsHeaders: true,
}

export enum KoppelingType {
  Standaard = 1,
  Dag = 2,
  Alle = 99,
}

export const koppelingTypeOptions: KoppelingType[] = [
  KoppelingType.Standaard,
  KoppelingType.Dag,
  KoppelingType.Alle,
]

export enum ProductType {
  B,
  P,
  A,
}
